import React, { Component } from "react";
import $ from "jquery";
import orderListUtil, { playClickSound, tmplparams } from "../../js/order-list-util";
import { connect } from "react-redux";
import LogoutButton from "../../components/icon-buttons/LogoutButton";
import AICommandBox from "../../js/ai/AICommandBox";
import auth, { getMyImageUrl, avoidMultipleClick, isDuplicateClickEvent, featureEnabled, getQuantityLabel, settingEnabled, lighten, stopPool, setRem } from "../../js/auth";
import EatWithMeText from "../../components/EatWIthMeText";
import ChangeLanguage from "../../components/icon-buttons/ChangeLanguage";
import UserImageButton from "../../components/icon-buttons/UserImageButton";
import BackButton from "../../components/menus/BackButton";
import FlexGrowSpace from "../../widgets/FlexGrowSpace";
import menuitemutil, { availableQuantities, filterChanged, getPlaces, refreshConnectedRestaurants, shouldDisplayUpsellField, toggleAllergen } from "../../js/admin/menuitem";
import { startpoll } from "../../js/auth";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import { capturePhotoWithData, crop } from "../../js/camera-util";
import HelpButton from "../../components/icon-buttons/HelpButton";
import { activeMenuCategories, activeMenuItems, getMenuCategoryOptions } from "../../js/tables-overview";
import { additionOptionIsChecked, includedInCategoryOption, orderMenuItem } from "../../js/orderMenuItem";
import admin, { getMenuCategory } from "../../js/admin";
import moment from "moment";
import { store } from "../..";
import EatWithMeActions from "../../actions/EatWithMeActions";
import CanAccess from "../../components/CanAccess";
import SubmenuHeader from "../../components/menus/SubMenuHeader";
import { I18n } from "react-redux-i18n";

const entityType = "Meal";
const entitytype = "meal";

class Meals extends Component {
  state = {
    initialized: false
  };

  openMenuAutomationWizard = (event) => {
    if (!menuitemutil.canUseAutomationWizard()) {
      return;
    }
    menuitemutil.openAutomationWizardDialog(event);
  };

  restoreMenuAutomationWizardIfNeeded = () => {
    if (!menuitemutil.canUseAutomationWizard()) {
      return;
    }
    if (menuitemutil.consumeAutomationWizardReopenOnEnter()) {
      menuitemutil.openAutomationWizardDialog();
    }
  };

  componentDidMount() {
    const { myStatus } = this.props;
    orderListUtil.props = this.props;
    menuitemutil.entityType = entityType;
    menuitemutil.entitytype = entitytype;
    window.menuitemutil = menuitemutil;
    window.capturePhotoWithData = capturePhotoWithData;
    window.crop = crop;
    window.avoidMultipleClick = avoidMultipleClick;
    window.isDuplicateClickEvent = isDuplicateClickEvent;
    window.featureEnabled = featureEnabled;
    window.settingEnabled = settingEnabled;
    window.orderMenuItem = orderMenuItem;
    window.getQuantityLabel = getQuantityLabel;
    window.includedInCategoryOption = includedInCategoryOption;
    window.getActiveMenuItems = activeMenuItems;
    window.getActiveMenuCategories = activeMenuCategories;
    window.getMenuCategory = getMenuCategory;
    window.getMenuCategoryOptions = getMenuCategoryOptions;
    window.additionOptionIsChecked = additionOptionIsChecked;
    window.filterChanged = filterChanged;
    window.playClickSound = playClickSound;
    window.lighten = lighten;
    window.moment = moment;
    window.getPlaces = getPlaces;
    window.admin = admin;

    if (myStatus && myStatus.restaurant_id) {
      auth.minfontsize = 10;
      setRem();
      this.ready(this.props);
      this.setState({ initialized: true });
      this.restoreMenuAutomationWizardIfNeeded();
    } 
    //if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
  }

  componentDidUpdate() {
    const { myStatus } = this.props;
    orderListUtil.props = this.props;

    if (myStatus && myStatus.restaurant_id && !this.state.initialized && this.props.restaurants) {
      auth.minfontsize = 10;
      setRem();
      this.ready(this.props);
      this.setState({ initialized: true });
      this.restoreMenuAutomationWizardIfNeeded();
    }
    //if (this.props?.myStatus?.sessionId) startpoll(auth.serverSideMessageHandler, [{ Restaurant: localStorage.restaurantSelected }]);
  }

  componentWillUnmount() {
    this.setState({ initialized: false });

    menuitemutil.closeAutomationWizardDialog({ rememberForReopen: true });

    delete window.menuitemutil;
    delete window.capturePhotoWithData;
    delete window.crop;
    delete window.avoidMultipleClick;
    delete window.isDuplicateClickEvent;
    stopPool();
  }

  render() {
    console.log("render");
    const { myStatus } = this.props;
    if (myStatus && myStatus.restaurant_id) {
      return (
        <div style={{ display: "flex", flexFlow: "column", flexGrow: 1, height: "100%", overflow: "hidden" }}>
          {!auth.isIncludedInFrame ? (
            <div className="menuItemHeader mealsheader">
              <SubmenuHeader
                {...this.props}
                header={I18n.t("admin_local.menus.meals")}
                showMenuAutomationWizardButton={menuitemutil.canUseAutomationWizard()}
                onOpenMenuAutomationWizard={this.openMenuAutomationWizard}
              />
            </div>
          ) : (
            ""
          )}
          <CanAccess resource="administration.products">
            <div id="meals" style={{ display: "contents", flexGrow: "100", height: "100%", overflow: "hidden" }}></div>
          </CanAccess>
          <input id="file" type="file" className="hidden"></input>
          <input id="foodorafile" type="file" className="hidden"></input>
          <input id="woltfile" type="file" className="hidden"></input>
          <div id="editMenuItemDialog" />
          {!auth.isIncludedInFrame ? <AICommandBox /> : ""}
        </div>
      );
    } else return null;
  }

  ready(props) {
    this.properties = props;
    menuitemutil.props = props;
    this.onloadIndexHtml();
    menuitemutil.initialize(props);
    menuitemutil.hooks();
    menuitemutil.reload();

  }

  onloadIndexHtml() {
    const webshopEnabled = featureEnabled('ordering/enabled') && ((featureEnabled('pickup/enabled') && featureEnabled('pickup/webshop')) || (featureEnabled('homedelivery/enabled') && featureEnabled('homedelivery/webshop')));
    $("#adminMenuitemTemplate")
      .tmpl({ entitytype: entitytype, ...tmplparams(), restaurants: this.properties.restaurants, webshopEnabled })
      .appendTo("#meals");
    $("#editMenuCategoryTemplate")
      .tmpl({ onsave: "menuitemutil.reload", entityType: entityType, entitytype: entitytype, availableQuantities: availableQuantities, webshopEnabled, ...tmplparams() })
      .appendTo("#meals");
    $("#editMenuItemTemplate")
      .tmpl({ onsave: "menuitemutil.reload", entityType: entityType, entitytype: entitytype, availableQuantities: availableQuantities, webshopEnabled, ...tmplparams() })
      .appendTo("#meals");

    $('input.connectedRestaurant').change(event => {
      var id = $(event.currentTarget).attr('id').split('-')[1];
      var checked = $(event.currentTarget).prop('checked');
      localStorage['restaurant_copy_selected_' + id] = checked;
      if (this.refreshConnectedRestaurants) clearTimeout(this.refreshConnectedRestaurants);
      this.refreshConnectedRestaurants = setTimeout(() => {
        this.refreshConnectedRestaurants = null;
        refreshConnectedRestaurants(undefined, true);
      }, 2000);
    });

    $("#allergens > label").on("click", toggleAllergen);
    $("#category_allergens > label").on("click", toggleAllergen);


    //{{tmpl({onsave:'menuitemutil.reload'}) editMenuCategoryTemplate}}
    //{{tmpl({onsave:'menuitemutil.reload'}) editMenuItemTemplate}}
    const pointOfSales = [];
    this.props.tables.forEach(table => {
      if (table.pos === true) pointOfSales.push(table);
    });
  }

  serverSideMessageHandler(message) {
    if (message.type === "timeout" && message.message === "true") return;
    if (message.type === "refresh") {
      if (message.message === "menu changed") {
        menuitemutil.getMenuItems(menuitemutil.processMenuItems);
      } else {
      }
    }
  }
}
const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      restaurants: props.rootReducer.restaurants,
      restaurant: props.rootReducer.restaurant,
      myStatus: props.rootReducer.myStatus,
      admin_local: props.rootReducer.admin_local,
      local: props.rootReducer.local,
      speechRecognitionOn: props.rootReducer.speechRecognitionOn,
      ai: props.rootReducer.ai,
      speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
      tables: props.rootReducer.tables
    };
  }
  return {};
};

export default connect(mapStateToProps)(Meals);
